<template>
    <div>
        <!-- Title and Logo -->
        <HeaderCard />
        <!-- end Logo and Title -->

        <!-- Panel Start here -->
        <panel title="LIST NPBU" class="panel panel-dark">
            <div class="my-3">
                <span class="px-2">
                    <b-button variant="primary" @click="create">
                        <i class="fa fa-plus"></i> Tambah NPBU
                    </b-button>
                </span>
                <span>
                    <b-button variant="primary" @click="reload">
                        <i class="fa fa-redo-alt"></i> Muat Ulang
                    </b-button>
                </span>
            </div>
            <div>
                <b-card class="shadow-sm rounded-0">
                    <!-- filter section -->
                    <b-row>
                        <b-col md="6" class="mb-3">
                            <b-form-group
                                :label-cols="3"
                                label="Filter By"
                                class="mb-0 my-1"
                            >
                                <b-input-group size="md">
                                    <b-form-select
                                        v-model="filterBy"
                                        :options="fieldOptions"
                                        @change="changeFilterBy()"
                                    >
                                        <option slot="first" :value="'all'"
                                            >All Data</option
                                        >
                                    </b-form-select>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group
                                :label-cols="3"
                                label="Filter"
                                class="mb-0"
                                description="Type to Search or Click Clear to Stop Searching "
                            >
                                <b-input-group size="md">
                                    <b-form-input
                                        v-model="filter"
                                        placeholder="Type to Search"
                                        debounce="500"
                                    />
                                    <b-input-group-append>
                                        <b-btn
                                            :disabled="!filter"
                                            @click="filter = ''"
                                            variant="info"
                                            >Clear</b-btn
                                        >
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group
                                :label-cols="3"
                                label="Sort"
                                class="mb-0 my-1"
                            >
                                <b-input-group size="md">
                                    <b-form-select
                                        v-model="sortBy"
                                        :options="fieldOptions"
                                    >
                                        <option slot="first" :value="null"
                                            >-- none --</option
                                        >
                                    </b-form-select>
                                    <b-form-select
                                        :disabled="!sortBy"
                                        v-model="sortDesc"
                                        slot="append"
                                    >
                                        <option :value="false">Asc</option>
                                        <option :value="true">Desc</option>
                                    </b-form-select>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <!-- end filter section -->
                    <!-- Data Table & Pagination -->
                    <b-table
                        show-empty
                        small
                        id="tableNpbu"
                        ref="tableNpbu"
                        head-variant="light"
                        :hover="true"
                        :busy.sync="isBusy"
                        :items="myGetData"
                        :fields="fields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :filter="filter"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        bordered
                        responsive
                    >
                        <template #cell(index)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template v-slot:table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner
                                    class="align-middle"
                                    small
                                    variant="primary"
                                ></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>

                        <template v-slot:table-colgroup="scope">
                            <col
                                v-for="field in scope.fields"
                                :key="field.key"
                                :style="{
                                    width:
                                        field.key === 'actions' ? '120px' : ''
                                }"
                            />
                        </template>
                        <template #head()="data">
                            <span style="white-space: pre;">{{
                                data.label
                            }}</span>
                        </template>

                        <!-- npbu -->
                        <template #cell(nama)="data">
                            <div v-if="data.item.nama">
                                <div v-if="data.item.bentuk_badan">
                                    {{ data.item.bentuk_badan.nama }}
                                </div>
                                <div>
                                    {{ data.item.nama }}
                                </div>
                            </div>
                        </template>

                        <!-- alamat -->
                        <template #cell(alamat)="data">
                            {{ data.item.alamat }}
                            <div v-if="data.item.wilayah_kelurahan">
                                <div>
                                    Kel. {{ data.item.wilayah_kelurahan.nama }}
                                </div>
                                <div>
                                    Kec.
                                    {{
                                        data.item.wilayah_kelurahan
                                            .wilayah_kecamatan.nama
                                    }}
                                </div>
                                <div>
                                    {{
                                        data.item.wilayah_kelurahan
                                            .wilayah_kecamatan.wilayah_kabkota
                                            .nama
                                    }}
                                </div>
                                <div>
                                    {{
                                        data.item.wilayah_kelurahan
                                            .wilayah_kecamatan.wilayah_kabkota
                                            .wilayah_provinsi.nama
                                    }}
                                </div>
                                <div>
                                    {{ data.item.kodepos }}
                                </div>
                            </div>
                        </template>

                        <!-- kontak -->
                        <template #cell(kontak)="data">
                            <div v-if="data.item.email">
                                <span class="font-weight-bold">Email:</span>
                                {{ data.item.email }}
                            </div>
                            <div v-if="data.item.notelepon">
                                <span class="font-weight-bold"
                                    >No. Telepon:</span
                                >
                                {{ data.item.notelepon }}
                            </div>
                            <div v-if="data.item.nomp">
                                <span class="font-weight-bold">No. Hp:</span>
                                {{ data.item.nomp }}
                            </div>
                        </template>

                        <!-- button actions -->
                        <template v-slot:cell(actions)="data">
                            <b-dropdown
                                split
                                class="m-r-2 d-flex align-item-center"
                                size="sm"
                                variant="info"
                            >
                                <template #button-content>
                                    <i class="fa fa-cogs"></i> Aksi
                                </template>
                                <b-dropdown-item @click="verifikasiNpbu(data.item)"
                                    ><i class="fa fa-check"></i>
                                    Verifikasi</b-dropdown-item
                                >
                                <b-dropdown-item @click="edit(data.item.id)"
                                    ><i class="fa fa-edit"></i>
                                    Edit</b-dropdown-item
                                >
                                <b-dropdown-item @click="remove(data.item.id)"
                                    ><i class="fa fa-trash-alt"></i>
                                    Hapus</b-dropdown-item
                                >
                            </b-dropdown>
                        </template>
                        <!-- end button actions -->
                    </b-table>
                    <div class="divider"></div>

                    <!-- pagination section -->
                    <b-row>
                        <div class="divider"></div>
                        <b-col md="6" class="my-0">
                            <b-form-group
                                :label-cols="2"
                                label="Per page"
                                class="mb-0"
                            >
                                <b-form inline>
                                    <b-form-select
                                        :options="pageOptions"
                                        style="width: 100px;"
                                        v-model="perPage"
                                    />
                                    <label class="ml-1 mr-1">/</label>
                                    <b-form-input
                                        :disabled="true"
                                        v-model="totalRows"
                                        style="width: 100px;"
                                        class="text-right"
                                    />
                                    <label class="ml-1">Rows</label>
                                </b-form>
                            </b-form-group>
                        </b-col>
                        <b-col md="6" class="my-0">
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="perPage"
                                align="fill"
                                size="md"
                                class="my-0 "
                            ></b-pagination>
                        </b-col>
                    </b-row>
                    <!-- end pagination section -->

                    <!-- end Data Table & Pagination -->
                </b-card>
            </div>
            <b-modal
                title="Verifikasi NPBU"
                v-model="helper.showModalVerifikasi"
                id="modalVerify"
                hide-footer
                no-close-on-backdrop
                size="lg"
            >
                <b-tabs
                    pills
                    nav-class="px-2 py-1"
                    nav-wrapper-class="bg-dark rounded text-white"
                    content-class="card p-5 my-2"
                    active-nav-item-class="bg-info"
                >
                    <b-tab
                        title="Profil Badan Usaha"
                        title-link-class="text-white"
                        active
                    >
                        <b-table-simple small bordered responsive>
                            <b-thead>
                                <b-tr>
                                    <b-td colspan="2">
                                        <h6>
                                            1. IDENTITAS BADAN USAHA
                                        </h6>
                                    </b-td>
                                </b-tr>
                            </b-thead>
                            <b-tr>
                                <b-td width="200px">
                                    NAMA PERUSAHAAN
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <span v-if="helper.npbu.bentuk_badan">
                                            {{ helper.npbu.bentuk_badan.kode }}
                                        </span>
                                        <span>
                                            {{ helper.npbu.nama }}
                                        </span>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    NIB
                                </b-td>
                                <b-td class="font-weight-bold">
                                    <div v-if="helper.npbu">
                                        {{ helper.npbu.no_induk }}
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    NOMOR POKOK
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        {{ helper.npbu.no_pokok }}
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    NO. HANDPHONE
                                </b-td>
                                <b-td class="font-weight-bold">
                                    <div v-if="helper.npbu">
                                        {{ helper.npbu.nomp }}
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    NO. TELEPON
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        {{ helper.npbu.notelepon }}
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    EMAIL
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        {{ helper.npbu.email }}
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    ALAMAT
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                            <div>
                                                {{ helper.npbu.alamat }}
                                            </div>
                                            <div v-if="helper.npbu.wilayah_kelurahan">
                                                <div>
                                                   Kel. {{ helper.npbu.wilayah_kelurahan.nama }}
                                                </div>
                                                <div>
                                                   Kec. {{ helper.npbu.wilayah_kelurahan.wilayah_kecamatan.nama }}
                                                </div>
                                                <div>
                                                   Kec. {{ helper.npbu.wilayah_kelurahan.wilayah_kecamatan.wilayah_kabkota.nama }}
                                                </div>
                                                <div>
                                                   Kec. {{ helper.npbu.wilayah_kelurahan.wilayah_kecamatan.wilayah_kabkota.wilayah_provinsi.nama }}
                                                </div>
                                                <div>
                                                    {{ helper.npbu.kodepos }}
                                                </div>
                                            </div>
                                    </div>
                                </b-td>
                            </b-tr>
                        </b-table-simple>
                        <b-table-simple simple bordered responsive>
                            <b-tr>
                                <b-td colspan="2">
                                    <h6>
                                        2. DATA REGISTRASI BADAN USAHA
                                    </h6>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    NO. REGISTRASI
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        {{ helper.npbu.no_registrasi }}
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    TGL. REGISTRASI
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    {{ helper.npbu.tgl_registrasi }}
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    STATUS REGISTRASI
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.status_registrasi">
                                            <div v-if="helper.npbu.status_registrasi_id == 1" class="label label-warning">
                                                Rekam Data
                                            </div>
                                            <div v-if="helper.npbu.status_registrasi_id == 2" class="label label-info">
                                                Kirim Permohonan
                                            </div>
                                            <div v-if="helper.npbu.status_registrasi_id == 3" class="label label-pink">
                                                Proses Verifikasi
                                            </div>
                                            <div v-if="helper.npbu.status_registrasi_id == 4" class="label label-danger">
                                                Ditolak
                                            </div>
                                            <div v-if="helper.npbu.status_registrasi_id == 5" class="label label-success">
                                                Disetujui
                                            </div>
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                        </b-table-simple>
                    </b-tab>
                    <b-tab title="Pimpinan" title-link-class="text-white">
                        <b-table-simple small bordered responsive>
                            <b-tr>
                                <b-td width="200px">
                                    NIK
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.pimpinan">
                                            {{ helper.npbu.pimpinan.nik }}
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    NAMA
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.pimpinan">
                                            {{ helper.npbu.pimpinan.nama }}
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    JABATAN
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.pimpinan">
                                            {{ helper.npbu.pimpinan.jabatan }}
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    NO. HANDPHONE
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.pimpinan">
                                            {{ helper.npbu.pimpinan.nomp }}
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    NO. TELEPON
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.pimpinan">
                                            {{ helper.npbu.pimpinan.notelepon }}
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    EMAIL
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.pimpinan">
                                            {{ helper.npbu.pimpinan.email }}
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    ALAMAT
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.pimpinan">
                                            {{ helper.npbu.pimpinan.alamat }}
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                        </b-table-simple>
                    </b-tab>
                    <b-tab
                        title="Penanggung Jawab"
                        title-link-class="text-white"
                    >
                        <b-table-simple small bordered responsive>
                            <b-tr>
                                <b-td width="200px">
                                    NIK
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.penanggung_jawab">
                                            {{ helper.npbu.penanggung_jawab.nik }}
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    NAMA
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.penanggung_jawab">
                                            {{ helper.npbu.penanggung_jawab.nama }}
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    JABATAN
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.penanggung_jawab">
                                            {{ helper.npbu.penanggung_jawab.jabatan }}
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    NO. HANDPHONE
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.penanggung_jawab">
                                            {{ helper.npbu.penanggung_jawab.nomp }}
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    NO. TELEPON
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.penanggung_jawab">
                                            {{ helper.npbu.penanggung_jawab.notelepon }}
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    EMAIL
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.penanggung_jawab">
                                            {{ helper.npbu.penanggung_jawab.email }}
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td width="200px">
                                    ALAMAT
                                </b-td>
                                <b-td class="font-weight-bold"> 
                                    <div v-if="helper.npbu">
                                        <div v-if="helper.npbu.penanggung_jawab">
                                            {{ helper.npbu.penanggung_jawab.alamat }}
                                        </div>
                                    </div>
                                </b-td>
                            </b-tr>
                        </b-table-simple>
                    </b-tab>
                </b-tabs>
                <b-card class="my-2">
                    <b-row>
                        <b-col sm="2">
                            Verifikasi Data:
                        </b-col>
                        <b-col sm="10">
                            <b-form-radio-group
                                id="radio-group-2"
                                v-model="form.status_registrasi_id"
                                name="radio-sub-component"
                            >
                                <b-form-radio value="1"
                                    >
                                        <span class="label label-warning">
                                            Rekam Data
                                        </span>
                                    </b-form-radio
                                >
                                <b-form-radio value="2"
                                    >
                                        <span class="label label-info">
                                            Kirim Permohonan
                                        </span>
                                    </b-form-radio
                                >
                                <b-form-radio value="3"
                                    >
                                        <span class="label label-pink">
                                            Proses Verifikasi
                                        </span>
                                    </b-form-radio
                                >
                                <b-form-radio value="4"
                                    >
                                        <span class="label label-danger">
                                            Ditolak
                                        </span>
                                    </b-form-radio
                                >
                                <b-form-radio value="5"
                                    >
                                        <span class="label label-success">
                                            Disetujui
                                        </span>
                                    </b-form-radio
                                >
                            </b-form-radio-group>
                        </b-col>
                    </b-row>
                    <b-row class="my-3">
                        <b-col sm="2">
                            Linimasa:
                        </b-col>
                        <b-col sm="10">
                            <b-form-textarea
                                id="textarea-large"
                                size="lg"
                                v-model="helper.linimasa"
                                placeholder="Masukkan Keterangan"
                                rows="6"
                                disabled
                            ></b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row class="my-0">
                        <b-col sm="2">
                            Keterangan:
                        </b-col>
                        <b-col sm="10">
                            <b-form-textarea
                                id="textarea-large"
                                size="lg"
                                v-model="form.ket_status"
                                placeholder="Masukkan Keterangan"
                                rows="6"
                            ></b-form-textarea>
                        </b-col>
                    </b-row>
                    <div class="my-2">
                        <span>
                            <b-button variant="primary" @click="verifikasiStatus" :disabled="helper.isLoading">
                                <b-spinner
                                    variant="light"
                                    label="Spinning"
                                    small
                                    v-if="helper.isLoading"
                                ></b-spinner>
                                <i class="fa fa-check-circle" v-else></i> Verifikasi
                            </b-button>
                        </span>
                        <span class="mx-2">
                            <b-button variant="outline-secondary" @click="hapusKeterangan">
                                <i class="fa fa-redo-alt"></i> Hapus Keterangan
                            </b-button>
                        </span>
                    </div>
                </b-card>
            </b-modal>
        </panel>
        <!-- Panel end here -->
    </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
// eslint-disable vue/no-unused-vars
// eslint-disable-line no-unused-vars
import HeaderCard from "@/components/header/HeaderCard.vue";
import axios from "axios";
import deleteMixins from "@/helper/delete_api";
import cekAuthMixins from "@/helper/cek401";
import resetMixins from "@/helper/resetForm";
import { mapState } from "vuex";
import pangkatMixin from "@/helper/pangkat/pangkat";

export default {
    mixins: [deleteMixins, cekAuthMixins, resetMixins, pangkatMixin],
    components: {
        HeaderCard
    },
    data() {
        return {
            // tools
            filter: "",
            filterBy: "all",
            sortBy: null,
            sortDesc: false,
            pageOptions: [5, 10, 15, 25],
            perPage: 10,
            currentPage: 1,
            totalRows: 0,
            isBusy: false,
            // field table
            fields: [
                {
                    key: "index",
                    label: "No.",
                    tdClass: "text-right"
                },
                {
                    key: "no_pokok",
                    label: "NPBU",
                    sortable: true
                },
                {
                    key: "nama",
                    label: "NAMA",
                    sortable: true
                },
                {
                    key: "no_induk",
                    label: "NIK"
                },
                {
                    key: "alamat",
                    label: "ALAMAT"
                },
                {
                    key: "kontak",
                    label: "KONTAK"
                },
                {
                    key: "actions",
                    label: "Opsi"
                }
            ],
            // modal
            showModal: false,
            editMode: false,
            isLoading: false,
            // v-form
            form: new Form({
                id: '',
                no_pokok: '',
                status_registrasi_id: '',
                ket_status: ''
            }),
            // helper variable
            helper: {
                errors: "",
                pangkat_id: "",
                showModalVerifikasi: false,
                npbu: '',
                linimasa: '',
                isLoading: false
            },
            tabIndex: 1
        };
    },
    computed: {
        fieldOptions() {
            // Create an options list from our fields
            return this.fields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        },
        // unit store variable
        ...mapState(["PemerintahDaerah"])
    },
    mounted() {
        // call unit option api (vuex)
        this.$store.dispatch("PemerintahDaerah/getPerangkatOptions");
    },
    methods: {
        // hot reload when input filter
        changeFilterBy() {
            if (this.filter) {
                this.$refs.tableNpbu.refresh();
            }
        },
        // data table
        myGetData(ctx) {
            // ctx =
            // berasal dari tag <b-table></b-table>
            //this.$Progress.start();
            this.isBusy = true;
            let promise = axios.get("/api/bumd/npbu", {
                params: {
                    page: ctx.currentPage,
                    perpage: ctx.perPage,
                    sortby: ctx.sortBy,
                    sortdesc: ctx.sortDesc,
                    filter: ctx.filter,
                    filterby: this.filterBy
                }
            });
            return promise
                .then(response => {
                    const items = response.data.data;
                    // Data Pagination
                    // configPagination(response.data.meta);
                    this.totalRows = response.data.meta.total;
                    // Here we could override the busy state, setting isBusy to false
                    //this.$Progress.finish();
                    this.isBusy = false;
                    // console.log(items);
                    return items;
                })
                .catch(error => {
                    // console.error(error);
                    // Here we could override the busy state, setting isBusy to false
                    //this.$Progress.fail();
                    this.isBusy = false;
                    if (error.response.status == 401) {
                        /* 
                        fungsi ini berasal dari cekAuthMixins 
                        cek pada folder 'helper'
                        */
                        this.cekAuth();
                    }
                    // Returning an empty array, allows table to correctly handle
                    // internal busy state in case of error
                    return [];
                });
        },
        // hapus data
        remove(id) {
            this.$swal({
                title: "Anda yakin ?",
                text: "Anda tidak akan bisa mengembalikan data!",
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonText: "Hapus",
                cancelButtonText: "Cancel",
                confirmButtonClass: "btn m-r-5 btn-danger",
                cancelButtonClass: "btn btn-default"
            }).then(result => {
                if (result.isConfirmed) {
                    // fungsi dari deleteMixins "cek folder 'helper'"
                    this.delete(id, "/api/bumd/npbu/");
                }
            });
        },
        // reload table
        reload() {
            this.$refs.tableNpbu.refresh();
        },
        // routing to tambah step npbu
        create() {
            this.$router.push({ name: "StepNpbu1" });
        },
        // edit routing
        edit(id) {
            this.$router.push({ name: "EditNpbu1", params: { id: id } });
        },
        // input Perangkat
        inputPerangkat(perangkatId) {
            if (perangkatId) {
                // 'PemerintahDaerah' vuex (cek folder store)
                this.$store.dispatch(
                    "PemerintahDaerah/getUnitOptions",
                    perangkatId
                );
            } else {
                this.form.unit_pd_id = "";
            }
        },
        verifikasiNpbu (data) {
            this.$root.$emit("bv::show::modal", "modalVerify");
            this.helper.showModalVerifikasi = true;
            this.helper.npbu = data
            this.form.status_registrasi_id = data.status_registrasi_id
            this.form.no_pokok = data.no_pokok
            this.form.id = data.id
            this.helper.linimasa = data.ket_status
        },
        // hapus keterangan
        hapusKeterangan () {
            this.form.ket_status = ''
        },

        // verifikasi status registrasi ['administrator']
        verifikasiStatus () {
            this.helper.isLoading = true
            this.form.put(`/api/bumd/npbu/verifikasi/${this.helper.npbu.id}`).then(response => {
                const items = response.data.data
                // console.log(items)
                this.helper.isLoading = false
                this.$swal({
                    icon: "success",
                    title: "Verifikasi berhasil.",
                    showConfirmButton: true,
                    showCloseButton: true,
                    confirmButtonText: "OKE",
                    confirmButtonClass: "btn btn-primary",
                    timer: 5000
                });
                this.helper.npbu.status_registrasi_id = items.status_registrasi_id
                this.form.status_registrasi_id = items.status_registrasi_id
                this.form.ket_status = ''
                this.reload()
            }).catch(error => {
                this.helper.isLoading = false
                if (error.response.status == 401) {
                    // mixins - cek if authenticated
                    this.cekAuth()
                }
            })
        }
    }
};
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
    border-color: red;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
    fill: #394066;
}
</style>
